import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ConvertToString from "../../../../components/Converter";

function PileInclinationVerticle({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.pileInclinationVertical")}</p>}
      inputValue={<span className="input">{ConvertToString(value, 2)}</span>}
      indicesValue={<span>&beta;</span>}
      unitValue={<span>°</span>}
      allowNegative={true}
    />
  );
}

export default PileInclinationVerticle;
